const reservar_vaga_aluno = {
  path: "/reservar_vaga_aluno",
  redirect: "/reservar_vaga_aluno",
  meta: {
    breadCrumb: "Atendimento ao Aluno - Reserva de Vaga",
  },
  children: [
    {
      path: "/reservar_vaga_aluno",
      name: "reservar_vaga_aluno",
      component: () =>
        import(
          "@/views/ReservaDeVagas/ReservaDeVagaDoAluno/ReservaDeVagaDoAlunoHome.vue"
        ),
    },
    {
      path: "/reservar_vaga_aluno_novo/:id",
      name: "reservar_vaga_aluno_novo",
      component: () =>
        import(
          "@/views/ReservaDeVagas/ReservaDeVagaDoAluno/ReservaDeVagaDoAlunoCad.vue"
        ),
    },
  ],
};

export { reservar_vaga_aluno };
